import React, { useState } from "react";

interface AccordionItemProps {
  question: string;
  answer: string | React.ReactElement;
  isOpen: boolean;
  onClick: () => void;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  question,
  answer,
  isOpen,
  onClick,
}) => {
  return (
    <>
      <button
        className={`accordion ${isOpen ? "active-a" : ""}`}
        onClick={onClick}
      >
        {question}
      </button>
      <div
        className="panel"
        style={{
          maxHeight: isOpen ? "1000px" : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
      >
        <div style={{ padding: isOpen ? "15px 0" : "0" }}>
          {typeof answer === "string" ? <p>{answer}</p> : answer}
        </div>
      </div>
    </>
  );
};

const FAQs: React.FC = () => {
  const [openAccordion, setOpenAccordion] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const faqsLeft = [
    {
      question: "What is STEM?",
      answer:
        "STEM stands for Science, Technology, Engineering, and Math, but it is much more than a sum of its parts. It is an approach to learning that integrates ALL content areas and promotes high levels of critical and creative thinking. The STEMCafe strategy emphasises student inquiry, projects, and community partnerships. Students are challenged to think creatively about real-world topics, to solve projects independently or collaborate, and to innovate.",
    },
    {
      question: "What is STEMCafe about?",
      answer:
        "STEMCafe is an interactive experience where kids channel their energy, excitement, curiosity and creativity through play.",
    },
    {
      question: "Is STEMCafe meant only for high ability students?",
      answer:
        "No. Students of all learning abilities, including kids with disabilities, will benefit from STEMCafe. Studies show that hands-on learning is beneficial to kids who have been disengaged (bored) with school. STEMCafe is for Kids from all backgrounds and abilities.",
    },
    {
      question:
        "Is STEMCafe only for a select number of kids interested in careers in math and science?",
      answer: (
        <>
          <p>
            Not at all. While increasing the number of young people who choose
            careers in STEM fields is certainly one objective driving STEMCafe,
            it is only part of the story. At STEMCafe, the experiential learning
            model develops skills that have a much broader application. We
            emphasize collaboration, communication, research, problem solving,
            critical thinking and creativity – skills that all kids need to be
            successful in today's world, regardless of specific interests or
            career goals.
          </p>
          <p>
            STEMCafe also places a strong emphasis on personalising experiences
            to best suit individual styles and interests, which means STEMCafe
            model has something to offer to every kid. We continually emphasise
            the importance of "STEM for All."
          </p>
        </>
      ),
    },
  ];

  const faqsRight = [
    {
      question: 'How do I know if STEMCafe is "right" for my child?',
      answer: (
        <>
          <p>
            If you believe your child learns best by:
            <br />- Sharing thoughts, questions, ideas, and solutions that lead
            to the completion of high-quality products
            <br />- Working together to reach a goal – putting talent,
            expertise, and abilities to work
            <br />- Looking at problems in a new way, linking learning across
            subjects and disciplines
            <br />- Trying new approaches to get things done equals innovation
            and invention
            <br />- Focusing on their natural curiosity and inquisitiveness
            <br />- Using self-monitoring skills and being capable of working
            independently
            <br />- Persevering to revise work in order to demonstrate mastery
          </p>
          <p>
            Then STEMCafe might be right for your child. However, there are no
            predetermined criteria for becoming a Member, just an open mind and
            a willingness to learn.
          </p>
        </>
      ),
    },
    {
      question: "Why is STEM important in Africa?",
      answer:
        "A STEM proficient is able to answer complex questions, investigate global issues,and develop solutions for challenges and real world problems while applying the rigor of science, technology, engineering, and mathematics content in a seamless fashion. STEM proficient kids are logical thinkers, effective communicators and are technologically, scientifically, and mathematically literate.",
    },
    {
      question:
        "There are no standardised tests for STEM. Why then should it matter for my child, if there is no accountability for it?",
      answer:
        "While there is not an official STEM standardised test, STEM aligns with concepts that are tested. Therefore, if your child is practicing exemplary STEM activities then he/she will be exposed to skills and concepts that have been tested.",
    },
    {
      question: "Covid-19 Safety Protocols",
      answer: (
        <p>
          - Maximum of 15 kids at once in the cafe (the space is big)
          <br />- Wearing a mask is compulsory for kids, staff, and anyone
          accompanying the kid to the cafe
          <br />- Temperature will be checked at the entrance
          <br />- Each kid will have a dedicated area, with increased
          supervision.
          <br />- The facilities will be disinfected every day. The toilets are
          disinfected after each use.
          <br />- It is important that parents make reservations before coming
          in so we can accommodate accordingly.
        </p>
      ),
    },
  ];

  return (
    <div id="faqs" className="p60">
      <div className="faq-avatar"></div>
      <div className="container">
        <h3>Frequently Asked Questions</h3>
        <p className="col-md-7 col-xs-12">
          STEMCafe provides a conducive and interactive environment where kids
          can channel their energy, excitement, curiosity and creativity
        </p>
        <div className="row">
          <div className="col-md-6">
            {faqsLeft.map((faq, index) => (
              <AccordionItem
                key={index}
                question={faq.question}
                answer={faq.answer}
                isOpen={openAccordion === index}
                onClick={() => toggleAccordion(index)}
              />
            ))}
          </div>
          <div className="col-md-6">
            {faqsRight.map((faq, index) => (
              <AccordionItem
                key={index + faqsLeft.length}
                question={faq.question}
                answer={faq.answer}
                isOpen={openAccordion === index + faqsLeft.length}
                onClick={() => toggleAccordion(index + faqsLeft.length)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
